import { Stack, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import PoweredByTradingView from "./components/PoweredByTradingView";
import { ANIM_PROFILE_DURATION, slideAnimationReverse } from "../../_app/animation-consts";
import Text from "../../_components/Text";
import { Trans, useTranslation } from "react-i18next";

const AboutPage = () => {
  const theme = useTheme();
  const { t } = useTranslation("profile");

  return (
    <PageLayout
      header={<Header pageTitle={t("about")} needBack />}
      contentSx={{ padding: "20px 8px 0" }}
    >
      <motion.div
        layout
        initial="in"
        animate="animate"
        exit="out"
        variants={slideAnimationReverse}
        transition={{ duration: ANIM_PROFILE_DURATION }}
      >
        <Stack direction={"column"} spacing={3}>
          <Text variant="regular" color={theme.myTheme.colors.foreground50}>
            <Trans i18nKey="ourAppText" ns="profile" />
          </Text>

          <PoweredByTradingView />
        </Stack>
      </motion.div>
    </PageLayout>
  );
};

export default AboutPage;
